import { Link } from 'react-router-dom';
import { projects } from '../../../mocks/projekte';

export default function ProjectsHero() {
  const completedCount = projects.length;

  return (
    <section className="relative pt-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/beb90bc8a8851b2861c529c8504b1104.jpg"
          alt="Unsere Projekte"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D2B4E]/85 via-[#0D2B4E]/70 to-[#0D2B4E]/40" />
      </div>

      <div className="relative container mx-auto px-4 sm:px-6 py-20 sm:py-28">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-white/60 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Startseite</Link>
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </div>
          <span className="text-white">Projekte</span>
        </nav>

        <div className="max-w-2xl">
          <span className="inline-block text-xs font-semibold tracking-widest text-white/70 uppercase mb-4">
            Referenzprojekte
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            Unsere abgeschlossenen Projekte
          </h1>
          <p className="text-base sm:text-lg text-white/80 leading-relaxed max-w-xl mb-8">
            Von der Bausanierung bis zum Traumgarten – hier sehen Sie, was wir für unsere Kunden
            geleistet haben. Jedes Projekt erzählt seine eigene Geschichte.
          </p>

          {/* Quick Stats */}
          <div className="flex flex-wrap gap-6 sm:gap-10">
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white">{completedCount}+</div>
              <div className="text-sm text-white/60 mt-0.5">Referenzprojekte</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white">7</div>
              <div className="text-sm text-white/60 mt-0.5">Leistungsbereiche</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white">100%</div>
              <div className="text-sm text-white/60 mt-0.5">Zufriedene Kunden</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
